/* eslint-disable */
// @ts-nocheck

import { defineStore } from "pinia";

type QuoteIdStoreType = {
  quoteId: string;
};

export const useQuoteIdStore = defineStore({
  id: "quote_id",
  state: () =>
    ({
      quoteId: ""
    }) as QuoteIdStoreType,
  getters: {
    quoteIdStore(): string {
      return this.quoteId;
    }
  },
  actions: {
    setQuoteId(quote_id) {
      this.quoteId = quote_id;
    },
    clearQuoteId() {
      this.quoteId = "";
    }
  }
});
